import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Mail, Linkedin, Star } from "lucide-react";

export default function Contact() {
  return (
    <div className="min-h-screen bg-[#0b1120] text-slate-200">
      <header className="border-b border-slate-800/70 bg-slate-950/60 backdrop-blur">
        <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="inline-flex items-center gap-2 text-slate-300 hover:text-white" data-testid="contact-back-home">
            <ArrowLeft size={16} /> Compass PM
          </Link>
          <div className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-blue-300/80">
            <Mail size={12} /> Contact
          </div>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 py-16" data-testid="contact-main">
        <h1 className="text-4xl sm:text-5xl font-bold text-white mb-4" style={{ fontFamily: "Outfit" }}>Get in touch</h1>
        <p className="text-slate-400 max-w-xl leading-relaxed">
          Questions about Compass PM, your account, billing, or enterprise plans? Send us an email and the
          Uplift Communications team will get back to you.
        </p>
        <a href="mailto:info@upliftc.com" data-testid="contact-email-link"
          className="mt-10 pc-card p-6 flex items-center gap-4 max-w-md hover:border-blue-500/50 transition-colors">
          <span className="w-12 h-12 rounded-xl bg-blue-500/15 border border-blue-500/30 grid place-items-center text-blue-300"><Mail size={20} /></span>
          <span>
            <span className="block text-[10px] uppercase tracking-widest text-slate-500">Email</span>
            <span className="block text-lg font-semibold text-white">info@upliftc.com</span>
          </span>
        </a>
        <a href="https://www.linkedin.com/company/uci-compasspm/" target="_blank" rel="noopener noreferrer" data-testid="contact-linkedin-link"
          className="mt-4 pc-card p-6 flex items-center gap-4 max-w-md hover:border-blue-500/50 transition-colors">
          <span className="w-12 h-12 rounded-xl bg-blue-500/15 border border-blue-500/30 grid place-items-center text-blue-300"><Linkedin size={20} /></span>
          <span>
            <span className="block text-[10px] uppercase tracking-widest text-slate-500">LinkedIn</span>
            <span className="block text-lg font-semibold text-white">Follow Compass PM</span>
          </span>
        </a>
        <a href="https://www.trustpilot.com/review/compasspm.app" target="_blank" rel="noopener noreferrer" data-testid="contact-trustpilot-link"
          className="mt-4 pc-card p-6 flex items-center gap-4 max-w-md hover:border-blue-500/50 transition-colors">
          <span className="w-12 h-12 rounded-xl bg-emerald-500/15 border border-emerald-500/30 grid place-items-center text-emerald-300"><Star size={20} /></span>
          <span>
            <span className="block text-[10px] uppercase tracking-widest text-slate-500">Trustpilot</span>
            <span className="block text-lg font-semibold text-white">Review us on Trustpilot</span>
          </span>
        </a>
        <footer className="mt-20 border-t border-slate-800/70 pt-6 text-xs text-slate-500">
          © 2026 Uplift Communications Corporation · Compass PM ·
          {" "}<Link to="/privacy" className="text-slate-400 hover:text-white" data-testid="contact-privacy-link">Privacy</Link>
        </footer>
      </main>
    </div>
  );
}
